// extracted by mini-css-extract-plugin
var _1 = "box--U0UWC3q";
var _2 = "button--xTDOuUF";
var _3 = "selected--sPEq0Ai";
export { _1 as "box", _2 as "button", _3 as "selected" }
